import { AbstractCommand } from 'src/models/command';

class RegisterUserFCMDeviceToken extends AbstractCommand {
	readonly name = 'IFS_User_Command_Command_RegisterUserFCMDeviceToken';

	public constructor(fcmDeviceToken: string) {
		super();
		this.parameters = {
			deviceToken: fcmDeviceToken,
		};
	}
}

export { RegisterUserFCMDeviceToken };
